import { render, staticRenderFns } from "./emptyTemplate.vue?vue&type=template&id=5e256bd6&scoped=true"
import script from "./emptyTemplate.vue?vue&type=script&lang=js"
export * from "./emptyTemplate.vue?vue&type=script&lang=js"
import style0 from "./emptyTemplate.vue?vue&type=style&index=0&id=5e256bd6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e256bd6",
  null
  
)

export default component.exports